import { createSelector } from 'reselect'

export const getValues = state => state.calculator.payload
export const getValidate = state => state.calculator.validate
export const getCalculate = state => state.calculator.response
export const getLoading = state => state.calculator.load
export const getCalculators = state => state.calculator.calculators
export const getWeight = state => state.calculator.weight

